import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit {
  eventsData = [
    {
      title: 'סדנא',
      smallHeader: 'הרשמו עוד היום',
      header: 'טיול גששות וספארי בדרום אפריקה',
      paragraph1: `תוכנית ייחודית זו משלבת בה את עולם הגששות ביחד עם מראות הספארי הייחודיים שיש לדרום אפריקה להציע. התוכנית מותאמת למשפחות ו/או בוגרים אשר מעוניינים בחוויה הרפתקנית ובלתי נשכחת נבקר בשלוש שמורות שונות ויחד נחפש את "חמשת הגדולים": אריה, נמר, פיל, קרנף ובאפאלו..
       תוכנית זו נבנתה לאחר שנים רבות בהן ביקרתי וגיששתי ברחבי דרום אפריקה ותלווה על ידי מדריכים מקומיים מעולים אותם אני מכיר באופן אישי.
      `,
      paragraph2: '',
      mainImg: 'assets/images/shared/course4.jpg',
      buttonTxt: 'צרו קשר',
      buttonUrl: '/contact-us'
    },
    {
      title: 'סדנא',
      smallHeader: 'הרשמו עוד היום',
      header: 'סדנת גששות למשפחות',
      paragraph1: ` בסדנה זו שאורכה כשעתיים, נכיר את העקרונות של אומנות
      ומדע הגששות. יחד נזכה להיכנס לעולמם האינטימי של בעלי החיים השונים בטבע.
      סדנא זו מותאמת לכל בני המשפחה ובמהלכה נחקור יחד עקבות וסימני שדה של יונקים, עופות, זוחלים וחרקים שונים
      `,
      paragraph2: '',
      mainImg: 'assets/images/shared/course3.jpg',
      buttonTxt: 'צרו קשר',
      buttonUrl: '/contact-us'
    },
    {
      title: 'סדנא',
      smallHeader: 'הרשמו עוד היום',
      header: ' סדנת אינטנסיב גששות מעקב לבוגרים',
      paragraph1: ` 3 ימים בהם נלמד לעקוב אחרי בעלי חיים שונים.
      זיהוי עקבות וסימנים ,תיארוך עקבות וסימנים, צבירת מומנטום על נתיב העקבות, מציאת העקבות מחדש לאחר איבודן, "כניסה לראש" החיה הבנה ופירוש התנהגויות שונות של בעלי החיים, למידת דפוסי עקבות, 
      טכניקות גישוש שונות ועוד...
     
      `,
      paragraph2: '',
      mainImg: 'assets/images/shared/course1.jpg',
      buttonTxt: 'צרו קשר',
      buttonUrl: '/contact-us'
    },
    {
      title: 'סדנא',
      smallHeader: 'הרשמו עוד היום',
      header: ' סדנת גששות לבוגרים',
      paragraph1: `
      בסדנה זו נכיר את יסודות הגששות, זהוי עקבות וסימני שדה, תיארוך של עקבות וסימני שדה, הבנה ופירוש התנהגויות שונות של בעלי חיים, ערנות ומודעות טבע.
      `,
      paragraph2: '',
      mainImg: 'assets/images/shared/course7.jpg',
      buttonTxt: 'צרו קשר',
      buttonUrl: '/contact-us'
    },
    {
      title: 'חוגים',
      smallHeader: 'הרשמו עוד היום',
      header: 'חוגים שבועיים למשפחות, ילדים ונוער',
      paragraph1: `מפגשים שבועיים של כשעה וחצי בהם נחקור יחד את הטבע באזור הפעילות, נלמד להכיר את עקבות וסימני השדה הנפוצים באזור, נחדד את החושים, נלמד לגשש דרך משחקים שונים ובעיקר נתחבר יחד לטבע.
      `,
      paragraph2: '',
      mainImg: 'assets/images/shared/course5.jpg',
      buttonTxt: 'צרו קשר',
      buttonUrl: '/contact-us'
    },
    {
      title: 'סדנא',
      smallHeader: 'הרשמו עוד היום',
      header: 'סדנא בהתאמה אישית',
      paragraph1: `בהתאם לרמת העניין, הידע והניסיון נוכל לקיים סדנא מותאמת אישית לצרכי הפונה. סדנאות כגון: מפגשים אישיים -אחד על אחד , אימוני גששות מתקדמים לאנשי שטח ואתגר,
      חגיגת אירועי חיים מיוחדים כגון: ימי הולדת, בר מצווה, ימי גיבוש לחברות ועוד
      `,
      paragraph2: '',
      mainImg: 'assets/images/shared/course6.jpg',
      buttonTxt: 'צרו קשר',
      buttonUrl: '/contact-us'
    }
  ];

  eventYearSchedule = [
    {
      day: '03',
      month: 'אוגוסט',
      title: 'בעקבות הדינוזאורים',
      time: 'ב3 באוגוסט שעה 17:00 ',
      city: 'חוף מכמורת'
    },
    {
      day: '03',
      month: 'אוגוסט',
      title: 'בעקבות הדינוזאורים',
      time: 'ב3 באוגוסט שעה 17:00 ',
      city: 'חוף מכמורת'
    },
    {
      day: '03',
      month: 'אוגוסט',
      title: 'בעקבות הדינוזאורים',
      time: 'ב3 באוגוסט שעה 17:00 ',
      city: 'חוף מכמורת'
    },
    {
      day: '03',
      month: 'אוגוסט',
      title: 'בעקבות הדינוזאורים',
      time: 'ב3 באוגוסט שעה 17:00 ',
      city: 'חוף מכמורת'
    },
    {
      day: '03',
      month: 'אוגוסט',
      title: 'בעקבות הדינוזאורים',
      time: 'ב3 באוגוסט שעה 17:00 ',
      city: 'חוף מכמורת'
    },
    {
      day: '03',
      month: 'אוגוסט',
      title: 'בעקבות הדינוזאורים',
      time: 'ב3 באוגוסט שעה 17:00 ',
      city: 'חוף מכמורת'
    }
  ];

  daySchduale = {
    date: 'יום שני , ה3 באפריל , 2020',
    data: [
      {
        lecturer: 'עודד דוידוביץ',
        from: '08:00',
        to: '10:00',
        description:
          'להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט  '
      },
      {
        lecturer: 'עודד דוידוביץ',
        from: '10:00',
        to: '12:00',
        description:
          'להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט  '
      },
      {
        lecturer: 'עודד דוידוביץ',
        from: '12:00',
        to: '15:00',
        description:
          'להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט  '
      },
      {
        lecturer: 'עודד דוידוביץ',
        from: '15:00',
        to: '19:00',
        description:
          'להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט להשלים טקסט  '
      }
    ]
  };
  constructor() { }

  ngOnInit() { }
}
